"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validateUIFormControlValidationMessage;

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

// #4597
function validateUIFormControlValidationMessage(props) {
  var validationMessage = props.validationMessage,
      error = props.error;

  if (validationMessage && !error) {
    _devLogger.default.warn({
      message: 'UIFormControl: Use of `error={false}` with `validationMessage` is discouraged.',
      url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/4597',
      key: 'UIFormControl: `error={false}` with `validationMessage`'
    });
  }
}

module.exports = exports.default;